import saveComments from './saveComments'
import getMatches from './getMatches'
import saveObsForm from './saveObsForm'

export const getMatchesService = getMatches
export const saveObsFormService = saveObsForm
export const saveCommentsService = saveComments 